<style scoped="scoped" lang="scss">
/* 新增样式 */
.video-title {
  // margin-bottom: 10px;
  margin: 10px 10px 10px 60px;
}
.video-box {
  margin-bottom: 10px;
  margin: 60px 10px 20px 60px;
}
.img-title {
  // margin-bottom: 10px;
  margin: 60px 10px 10px 60px;
}
.img-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  // margin-top: 10px;
  margin: 2px 10px 20px 60px;
}
.img-item {
  width: 100px;
  height: 100px;
  border: 1px solid #eee;
  border-radius: 4px;
}
.empty-text {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
  color: #999;
  font-size: 14px;
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/equipment/check/bill/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('dianjiandanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_cross_select :max="1" :component="'web_base_equipment_list'" :ids.sync="yt.conditions.equipmentId"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('dianjianzhuangtai')">
            <yi_dictionary_select :type="'EQUIPMENT_CHECK_STATUS'" :ids.sync="yt.conditions.status"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('dianjianjieguo')">
            <yi_dictionary_select :type="'EQUIPMENT_CHECK_RESULT'" :ids.sync="yt.conditions.result"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jihuadianjianshijian')">
            <yi_time_input type="datetime" value-format="timestamp" :time.sync="yt.conditions.planTime"> </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('dianjianxiang', scope.row, '70%')" v-if="utils.checkPower('web_equipment_check_item_page')">
              {{ $t('dianjianxiang') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button
              type="text"
              @click="
                yt.showEditDialog('shipingtupianchakan', scope.row, '70%');
                beforeSetting(scope.row);
              "
              v-if="utils.checkPower('web_equipment_check_item_page') && scope.row.status === 3"
            >
              {{ $t('shipingtupian') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="scope.row.status == 1 && utils.checkPower('web_equipment_check_delete')" type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/equipment/check/bill/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 点检项 -->
      <template v-if="yt.editObj.action == 'dianjianxiang'">
        <div class="dialog-scroller">
          <check_item :equipment="yt.editObj" ref="checkItem"></check_item>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button v-if="!(yt.editObj.status == 3 || yt.editObj.status == 2)" size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button v-if="!(yt.editObj.status == 3 || yt.editObj.status == 2)" size="mini" @click="submitCheckItem(yt.editObj)" type="primary" :loading="yt.editObj.loading" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '设备点检-提交点检' } }">
            {{ $t('tijiao') }}
          </el-button>
        </span>
      </template>
      <!-- 视频图片查看 -->
      <template v-if="yt.editObj.action == 'shipingtupianchakan'">
        <div class="dialog-scroller">
          <!-- 视频区域 -->
          <div v-if="videoPath" class="video-title">{{ $t('shipin') }}</div>
          <div class="video-box" v-if="videoPath">
            <video width="200" height="150" :src="videoPath" controls></video>
          </div>
          <!-- <div class="empty-text" v-if="!videoPath && imgUrlList.length === 0">暂无视频和图片</div> -->
          <el-empty class="empty-text" v-if="!videoPath && imgUrlList.length === 0" description="暂无视频和图片"></el-empty>

          <!-- 多张图片循环展示 -->
          <div v-if="imgUrlList.length > 0" class="img-title">{{ $t('tupian') }}</div>
          <!-- 图片 -->
          <div class="img-wrap" v-if="imgUrlList.length > 0">
            <el-image v-for="(url, idx) in imgUrlList" :key="idx" :src="url" fit="contain" class="img-item" preview :preview-src-list="imgUrlList"></el-image>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button v-if="!(yt.editObj.status == 3 || yt.editObj.status == 2)" size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button v-if="!(yt.editObj.status == 3 || yt.editObj.status == 2)" size="mini" @click="submitCheckItem(yt.editObj)" type="primary" :loading="yt.editObj.loading" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '设备点检-提交点检' } }">
            {{ $t('tijiao') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import check_item from '@@/pages/web/equipment/check/check_item';
export default {
  name: 'web_equipment_check_list',
  components: {
    check_item
  },

  data() {
    return {
      leaveFactoryDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
      list: [],
      videoPath: '',
      // imgList: [],
      imgUrlList: [], // 纯URL字符串数组（给preview用）
      columns: [
        {
          label: 'dianjiandanhao',
          prop: 'no'
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name'
        },
        {
          label: 'dianjianzhuangtai',
          prop: 'status',
          type: 'dictionary_tag',
          key: 'EQUIPMENT_CHECK_STATUS'
        },
        {
          label: 'jihuadianjianshijian',
          prop: 'planTime',
          type: 'time'
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: 'dianjianjieguo',
          prop: 'result',
          type: 'dictionary_tag',
          key: 'EQUIPMENT_CHECK_RESULT'
        },
        {
          label: 'dianjianren',
          prop: 'checkUser.nickname'
        },
        {
          label: 'dianjianshijian',
          prop: 'checkTime',
          type: 'time'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 180,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
      this.getEquipmentName();
    }, 300);
  },

  methods: {
    beforeSetting(obj) {
      // 每次打开弹窗先清空
      this.videoPath = '';
      // this.imgList = [];
      this.imgUrlList = [];

      this.http
        .get('/web/equipment/check/bill/get', {
          params: {
            id: obj.id
          }
        })
        .then(res => {
          this.videoPath = res.data.videoPath || '';
          const ids = res.data.fileIds;
          // 修复：判断 fileIds 存在且不为空
          if (Array.isArray(ids) && ids.length > 0) {
            const idStr = ids.join(',');
            this.getFileByIds(idStr);
          }
        });
    },
    getFileByIds(ids) {
      return this.http
        .get('/web/customer/files/getFileByIds', {
          params: {
            ids: ids
          }
        })
        .then(res => {
          // 接口返回图片数组，直接赋值给图片列表
          this.imgUrlList = (res.data || []).map(item => item.url);
        });
    },
    submitCheckItem(value) {
      this.yt.editObj.loading = true;
      this.http
        .post('web/equipment/check/bill/commit', {
          id: value.id,
          remark: value.remark,
          itemList: this.$refs.checkItem.$refs.yt.list
        })
        .then(res => {
          this.yt.isShowEditDialog = false;
          this.yt.get(1);
        })
        .catch(e => {
          this.$message.error(this.$t(e));
        })
        .finally(() => {
          this.yt.editObj.loading = false;
        });
    }
  }
};
</script>
